export default __webpack_public_path__ + "static/media/pranay.2fafd32d.jpeg";